<template>
  <el-container>
    <div class="about">
      <h1>This is an about page</h1>
    </div>

    <div>
      <treeselect
        v-model="value"
        :options="options"
        :multiple="true"
        placeholder="Select..."
      />
    </div>

    <div>
      <a-space wrap>
        <a-button type="primary">Primary Button</a-button>
        <a-button>Default Button</a-button>
        <a-button type="dashed">Dashed Button</a-button>
        <a-button type="text">Text Button</a-button>
        <a-button type="link">Link Button</a-button>
      </a-space>
    </div>

    <div class="whi"></div>

    <el-row class="tops-layout2">
      <el-col :span="12" class="pl10">
        <el-link class="el-dropdown-left"><i class="el-icon-s-fold"></i></el-link>
      </el-col>
      <el-col :span="12" class="pr10">
        <el-link class="el-dropdown-right"><i class="el-icon-user"></i></el-link>
      </el-col>
    </el-row>

  </el-container>
  
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { Button } from 'ant-design-vue';

export default {
  name: 'about',
  components: {
    AButton: Button,
    Treeselect,
  },
  data() {
    return {
        value: null,
        options: [
          {
            id: 1,
            label: 'Option 1',
            children: [
              { id: 2, label: 'Option 1.1' },
              { id: 3, label: 'Option 1.2' }
            ]
          },
          { id: 4, label: 'Option 2' }
        ]
    }
  }
}
</script>

<style scoped>
.whi {
  width: 100%;
  height: 50px;
}
.tops-layout {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  
  border: #cccccc 1px solid;
}
.layout-left {
    display: flex;
    justify-content: flex-end;
    flex: 0 0 50%;
    width: 100%;
}
.layout-right {
    display: flex;
    justify-content: flex-end;
    flex: 0 0 50%;
}

.tops-layout2 {
  width: 100%;
  height: 40px;
  align-items: center;
  border: #cccccc 1px solid;
}
.tops-layout2>.el-col {
  height: 40px;
  align-items: center;
}
.linklay-right {
  float: right;
  margin-right: 10px;
}
.el-dropdown-left, .el-dropdown-right {
    display: inline-flex;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    position: relative;
    vertical-align: top;
    margin-right: 10px;
}
.el-dropdown-left {
  float: left;
}
.el-dropdown-right {
  float: right;
}
.pl10 {
    padding-left: 10px !important;
}
.pr10 {
    padding-right: 10px !important;
}
</style>